<div class="dynamic-field" [formGroup]="group">
  <label for="controlNetworkSelect">{{ config.label | translate }}</label>
  <select
    id="controlNetworkSelect"
    class="form-select"
    [formControlName]="config.name"
    [ngClass]="{ error: isErrorDetected() }"
    >
    @if (config.allValuesEnabled) {
      <option value="">
        {{ 'GK.DYNAMIC_FORM.ALL' | translate }}
      </option>
    }
    @for (controlNetwork of controlNetworks; track controlNetwork) {
      <option
        [value]="controlNetwork.id"
        >
        {{ controlNetwork.name }}
      </option>
    }
  </select>
</div>
